import React, { FC } from 'react';
import { observer } from 'mobx-react';
import Link from 'next/link';
import { useTranslation } from 'react-i18next';
import { MenuFlyout } from '@components/MenuFlyout';
import { LogoutIcon, UserSettingIcon } from '@components/icons';
import { uiStore } from '@stores/UiStore';
import { HiOutlineKey } from '@react-icons/all-files/hi/HiOutlineKey';
export const SidebarHeader: FC<{
  collapsed: boolean;
  onClick: () => void;
}> = observer(({
  collapsed,
  onClick
}) => {
  const {
    t
  } = useTranslation();
  return <div className={`
          m-2 flex items-center justify-between px-2 select-none
          md:w-1/2 md:w-auto
        `}>
        {!collapsed && <div className={`
              relative flex h-24 items-center justify-center
              ${collapsed ? 'p-2' : 'gap-x-2'}
            `}>
            <img className="w-14" src="/static/assets/lf-logo-light-compact.svg" />

            <img src="/static/assets/lf-logo-light-text.svg" className="flex w-full" />
          </div>}

        <div className="flex flex-row gap-x-1">
          <button className={`
              flex h-14 w-14 items-center justify-center rounded-[5px] p-2
              hover:bg-spindle
            `} onClick={onClick}>
            <img data-tooltip-id="main-tooltip" data-tooltip-delay-show={1000} data-tooltip-content={collapsed ? t('sidebarVisible') : t('sidebarHide')} src="/static/assets/sidebar-menu.svg" />
          </button>

          {!collapsed && <MenuFlyout customMenu={<div className={`w-full text-grey`}>
                  <Link href="/user/preferences" onClick={() => {
          if (window.innerWidth < 768 && uiStore.sidebar.open) {
            uiStore.sidebar.toggleSidebar();
          }
        }}>
                    <div className={`
                        flex cursor-pointer flex-row items-center justify-start py-3 ps-5
                        hover:text-secondary-300
                      `}>
                      <div className={`
                          w-12 p-2
                          md:w-12
                        `}>
                        <UserSettingIcon />
                      </div>
                      <p className={`ml-4 font-semibold`}>{t('preferences')}</p>
                    </div>
                  </Link>
                  <Link href="/user/passkeys" onClick={() => {
          if (window.innerWidth < 768 && uiStore.sidebar.open) {
            uiStore.sidebar.toggleSidebar();
          }
        }}>
                    <div className={`
                        flex cursor-pointer flex-row items-center justify-start py-3 ps-5
                        hover:text-secondary-300
                      `}>
                      <div className={`
                          w-12 p-2
                          md:w-12
                        `}>
                        <HiOutlineKey />
                      </div>
                      <p className={`ml-4 font-semibold`}>{t('passkeys')}</p>
                    </div>
                  </Link>
                  <Link href={'/logout'}>
                    <div className={`
                        flex cursor-pointer flex-row items-center justify-start border-t-1
                        border-spindle py-3 ps-5
                        hover:text-secondary-300
                      `}>
                      <div className={`
                          w-12 p-2
                          md:w-12
                        `}>
                        <LogoutIcon />
                      </div>
                      <p className={`ml-4 font-semibold`}>Logout</p>
                    </div>
                  </Link>
                </div>} icon={<img src="/static/assets/user-icon.svg" />} customStyles={{
        button: `h-14 w-14 rounded-md p-2 hover:bg-spindle flex items-center justify-center`,
        top: 'top-15',
        bottom: 'bottom-0',
        padding: 'p-0'
      }} />}
        </div>
      </div>;
});